import React from "react"
import { Link } from "gatsby"
import Wrapper from "@components/Wrapper"
import styles from "./Highlights.module.scss"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"

const Highlights = props => {

  function samlMessage() {
    if( props.pathContext.saml ) {
      return <span className={"proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"}>Single Sign-On (SAML 2.0)</span>;
    }
  }

  function ssoAgentMessage() {
    console.log(props.pathContext);
    if( props.pathContext.ssoAgent ) {
      return <span className={"proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"}>Single Sign-On (Agent)</span>;
    }
  }

  function provMessage() {
    if( props.pathContext.prov ) {
      return <span className={"proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"}>Automated provisioning with {props.pathContext.appName}</span>;
    }
  }

  function docoMessage() {
    if( props.pathContext.doco ) {
      return <div>
        <p className={
            styles.docoDescription +
            " proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"
          }
        >
          Looking for instructions for integrating EngineID with {props.pathContext.appName}?
        </p>
        <p className={
            styles.docoLink + 
            " proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"
          }>
          <OutboundLink target="_blank" href={props.pathContext.doco}>View the technical documentation</OutboundLink>
        </p>
      </div>;
    }
  }

  return (
    <section className="container-fluid bg-xl-light-gray">
      <div className="row ml-0 mr-0">
        <Wrapper className={"w-100 text-center"} gap="outer">
          <div className="row bg-white">
            <div className="col-12">
              <img className={ styles.appHeaderImage } src={require("../../../images/apps/" + props.pathContext.icon)} />
              <p
                className={
                  styles.topDescription +
                  " proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"
                }
              >
                Integrating with {props.pathContext.appName} has never been easier with EngineID. We know that setting up employees or customers
                with individual access to all the software they need burns time and resources. When staff or customers have to memorize separate
                logins for multiple apps, there's inevitable costly pressure on you and your help desk.
              </p>
              <p
                className={
                  styles.topDescription +
                  " proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"
                }
              >
                That's why we've created a comprehensive identity and access management solution for small and medium companies. You have control
                over who has access to which applications - inside the firewall or on the cloud. It's more secure than maintaining individual logins
                for every system but exponentially faster to set up and lock down.
              </p>
              <p
                className="proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto">
                For {props.pathContext.appName}, EngineID provides the following integration capabilities:
              </p>
              <div className={
                  styles.list + " " +
                  styles.bulletDescription +
                  " proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"}>
                {samlMessage()}
                {ssoAgentMessage()}
                {provMessage()}
              </div>
              {docoMessage()}
              <p className={
                  " proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"
                }
              >
                Want to know more?
              </p>
              <p className={
                  "proxima-nova--semi-bold fs-18pt fs-lg-22pt mx-auto"
                }>
                <Link
                  to="/contact-us"
                >
                  Get In Touch!
                </Link>
              </p>
            </div>
          </div>
        </Wrapper>
      </div>
    </section>
  )
}

export default Highlights
